var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React, { useCallback } from "react";
import { Overlay } from "../../overlay/Overlay";
import { OverlayHeader } from "../../overlay/Header";
import { OverlayBody } from "../../overlay/Body";
import { OverlayContainer } from "../../overlay/Container";
import { menuVerticalOverlayCls, menuVerticalOverlayHeaderCls, menuVerticalOverlayBodyCls } from "./Overlay.less";
function MenuVerticalOverlay(_ref) {
  var active = _ref.active, _ref$topOffset = _ref.topOffset, topOffset = _ref$topOffset === void 0 ? 0 : _ref$topOffset, children = _ref.children, _ref$header = _ref.header, header = _ref$header === void 0 ? null : _ref$header, _ref$align = _ref.align, align = _ref$align === void 0 ? "right" : _ref$align, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? null : _ref$onClose;
  var handleClose = useCallback(function(e) {
    e.preventDefault();
    if (typeof onClose === "function") {
      onClose();
    }
  }, [onClose]);
  return /* @__PURE__ */ React.createElement(Overlay, {
    sidebar: true,
    sidebarAlign: align,
    type: "semitransparent",
    isVisible: active,
    onClose: handleClose,
    topOffset,
    className: menuVerticalOverlayCls,
    closeOnOutsideClick: true
  }, /* @__PURE__ */ React.createElement(OverlayContainer, null, header ? /* @__PURE__ */ React.createElement(OverlayHeader, {
    className: menuVerticalOverlayHeaderCls,
    border: false
  }, header) : null, /* @__PURE__ */ React.createElement(OverlayBody, {
    className: menuVerticalOverlayBodyCls
  }, children)));
}
__name(MenuVerticalOverlay, "MenuVerticalOverlay");
export {
  MenuVerticalOverlay
};
